export default class CreateServiceConfigModel {
  serviceCode?: string;

  description?: string;
}
